import React from "react";
import { Modal, ModalContent, ModalBody, Checkbox, Button } from "@nextui-org/react";

function ContactModal({ isOpen, onClose, userdata }) {
  return (
    <Modal size={"md"} isOpen={isOpen} onClose={onClose} placement="center">
      <ModalContent>
        {(onClose) => (
          <ModalBody>
            <h1 className="text-center font-semibold text-2xl text-gray-800">
              Contract Info
            </h1>
            <div className="h-[400px] px-2 overflow-y-scroll border border-gray-400 rounded-lg">
              <p className="text-xs mt-2">
                By agreeing to the terms and conditions mentioned in this document, you are bound to follow all the instructions as mentioned below.
              </p>
              {userdata?.details?.role === "SUPPLIER" ? (
                <div className="my-2 py-1">
                  <h2 className="font-semibold text-md my-2 text-gray-700">1. Supplier Agreement</h2>
                  <p className="text-xs">
                    This agreement includes all the terms and conditions that a supplier must follow to use the website smoothly...
                  </p>
                  <h2 className="font-semibold text-md my-2 text-gray-700">2. General Guidelines for Suppliers</h2>
                  <p className="text-xs">
                    Suppliers must provide full, correct, true, and accurate information regarding the products...
                  </p>
                </div>
              ) : (
                <div className="my-2 py-1">
                  <h2 className="font-semibold text-md my-2 text-gray-700">1. Collection of your info</h2>
                  <p className="text-xs">
                    If you are using this website, you are responsible for maintaining the confidentiality of your account...
                  </p>
                </div>
              )}
            </div>
            <div className="mt-1 mb-1">
              <Checkbox required size="sm" color="blue">
                Accept Terms and Conditions
              </Checkbox>
            </div>
            <div className="grid grid-cols-4 gap-2 pb-3">
              <div></div>
              <div></div>
              <Button className="border-2 h-8 border-orange-500 text-orange-500 bg-transparent" onClick={onClose}>
                Cancel
              </Button>
              <Button className="border-2 h-8 border-green-500 text-green-500 bg-transparent">
                Next
              </Button>
            </div>
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  );
}

export default ContactModal;
